import React from "react";
import "./section.css";

function Section() {
  return (
    <section className="main-section">
      <div className="section-content">
        <h1>
          You’re <span className="curved">Health</span>
        </h1>
        <h2>Our Priority</h2>
        <p>
          At Shri Adithya Hospital, we don’t just treat conditions.
          <br />
          From the moment you walk in, our focus is on you —<br />
          your comfort, your concerns, and your recovery.
        </p>
      </div>
    </section>
  );
}

export default Section;
